{
  "collapse": " Skupi",
  "expand": "Proširi"
}
